import Cart from "./cart";

class Header {
  constructor() {
    this.stickyHeader();
    this.navigation();
    this.megaMenu();
    this.searchBox();
    new Cart();
  }

  megaMenu = () => {
    const menuItems = document.querySelectorAll(".menu-item-has-children");
    const menuitemsResponsive = document.querySelectorAll(
      ".js-menu-item-responsive"
    );
    menuItems.forEach((item) => {
      item.addEventListener("mouseover", () => {
        if (window.innerWidth > 1279) {
          document.querySelector(".js-header").classList.add("active");
        }
      });
      item.addEventListener("mouseout", () => {
        if (window.innerWidth > 1279) {
          document.querySelector(".js-header").classList.remove("active");
        }
      });

      item.addEventListener("click", (e) => {
        e.stopPropagation();
        if (window.innerWidth < 1280) {
          let openedMenu = e.target.querySelector(".sub-menu");
          openedMenu.classList.toggle("active");
          e.target.classList.toggle("active");
          this.closeSubMenus(item, openedMenu, e.target);
        }
      });
    });
    menuitemsResponsive.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.stopPropagation();
        if (window.innerWidth < 768) {
          let openedMenu = e.target.parentNode;
          openedMenu.classList.remove("active");
        }
      });
    });
  };

  closeSubMenus = (item, openedMenu, activeItem) => {
    const menus = item.parentNode.querySelectorAll(".sub-menu");
    const menuItems = item.parentNode.querySelectorAll(
      ".menu-item-has-children"
    );
    menuItems.forEach((i) => {
      if (i != activeItem) {
        i.classList.remove("active");
      }
    });
    menus.forEach((menu) => {
      if (menu != openedMenu) {
        menu.classList.remove("active");
      }
    });
  };

  navigation = () => {
    const toggleBtn = document.querySelector(".js-navigation-toggler");
    const nav = document.querySelector(".js-navigation");
    const header = document.querySelector(".js-header");
    toggleBtn.addEventListener("click", (e) => {
      toggleBtn.classList.toggle("open");
      nav?.classList.toggle("open");
      header?.classList.toggle("active");
      document.body.classList.toggle("stop-scroll");
    });
  };

  searchBox = () => {
    const searchBtn = document.querySelector(".js-search-btn");
    const searchBox = document.querySelector(".js-search-box");
    const input = searchBox?.querySelector("input");
    searchBtn.addEventListener("click", () => {
      searchBox.classList.toggle("active");
      if (searchBox.classList.contains("active")) {
        input.focus();
      }
    });
    input.addEventListener("focusout", () => {
      searchBox.classList.remove("active");
    });
  };

  stickyHeader = () => {
    const header = document.querySelector(".js-header");
    let prevPosY = window.scrollY;
    if (window.scrollY > 10) {
      header.classList.add("not-top");
    }

    addEventListener("scroll", () => {
      const posY = window.scrollY;
      if (posY < 10) {
        header.classList.remove("not-top");
      } else {
        header.classList.add("not-top");
      }
      if (posY <= prevPosY || posY <= 0) {
        header.classList.remove("hide");
      } else {
        header.classList.add("hide");
      }
      prevPosY = posY;
    });
  };
}
new Header();
